
import { CoordsModel } from "@components/livemap/model/CoordsModel";
import { ICommonMapComponent } from "@directives/_map/v-map/v-map/v-map.component";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { ICombinedPreferences } from "@interfaces/ICombinedPreferences";
import { IGeofence } from "@interfaces/IGeofences";
import { AccountFeatureService, UserRole } from "@services/accountFeature.service";
import { FullScreenService } from "@services/fullscreen.service";
import { MapService } from "@services/map.service";
import { SessionService } from "@services/session.service";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { SettingsName } from "src/app/class/SettingsName";
import "./veriMap.scss";

export enum MapPopupType {
    Cluster,
    Vehicle,
    Plot,
    Geofence,
    RightClick,
    Custom
}

export interface IVeriMapChildComponent {
    getLatLngsForFitMap?(): google.maps.LatLng[];

    onMapLoad?(): void;
    onMapIdle?(): void;
    onMouseMove?(position: google.maps.LatLng, event: Event): boolean;
}

export interface IVeriMapComponent extends ICommonMapComponent {
    //getMap(): google.maps.Map;
    getMapOffsetCenter(): google.maps.LatLng;
    //fitMap(latLngs: google.maps.LatLng[] | google.maps.LatLngLiteral[]);
    fitMapToAll();
    panMap(latLng: google.maps.LatLng);
    setCenter(latLng: google.maps.LatLng);
    smoothPanAndZoomTo(latLng: google.maps.LatLng, targetZoom: number): angular.IPromise<void>;
    clearData(): void;

    registerChildComponent(childComponent: IVeriMapChildComponent);
    deregisterChildComponent(childComponent: IVeriMapChildComponent);

    showPopup(popupType: MapPopupType, position: google.maps.LatLng, model: any, hideControls?: boolean);
    hidePopup(popupType: MapPopupType, immediate: boolean);
    setPopupPosition(position: google.maps.LatLng);

    mapOffset: google.maps.Point;
    userOptions: ICombinedPreferences;

    mapInitialised: boolean;
    mapInitialisedPromise: angular.IPromise<google.maps.Map>;

    greyscale: boolean;
    disablePopup: boolean;

    disableDefaultUi: boolean;
    showControlsOnRight: boolean;
}

interface IVeriMapBindings {
    mapCenter: CoordsModel;
    mapZoom: number;
    mapOffset: google.maps.Point;
    updateMapSize: any;
    updateMapSizeAndFit: any;

    showFullScreen: boolean;
    showSearch: boolean;
    includeVehicleSearch: boolean;
    hideGeofences: boolean;

    showResourceToggle: boolean;
    showIgnitionOffToggle: boolean;
    ignitionOffCount: number;

    onPopupClick: () => void;
    onEditGeofenceClick: (args: { geofence: IGeofence }) => void;
    onMapLoaded: (args: { veriMap: IVeriMapComponent }) => void;
    onMapUnloaded: (args: { veriMap: IVeriMapComponent }) => void;
    onMapIdle(args: { veriMap: IVeriMapComponent });
    onMapBoundsChanged: (args: { veriMap: IVeriMapComponent }) => void;
    onShowPopup: (args: { position: google.maps.LatLng, model?: any }) => void;
    onGeofenceClicked: (args: { geofence: IGeofence }) => void;
    onToggleResource: (args: { show: boolean }) => void;
    onToggleIgnitionOff: (args: { show: boolean }) => void;
}

class VeriMapComponentController implements angular.IComponentController, IVeriMapBindings, IVeriMapComponent {

    popupHideControls: boolean;
    popupType: MapPopupType;
    popupLatLng: google.maps.LatLng;
    popupPosition: google.maps.Point;
    popupModel: any;
    //popupAboutToClose: boolean;

    mapObject: google.maps.Map;
    mapCenter: CoordsModel;
    mapZoom: number;
    mapOffset: google.maps.Point;
    updateMapSize: any;
    updateMapSizeAndFit: any;

    showFullScreen: boolean;
    showResourceToggle: boolean;
    showIgnitionOffToggle: boolean;
    showResource: boolean = true;
    showIgnitionOff: boolean = false;
    ignitionOffCount: number;
    showSearch: boolean;
    includeVehicleSearch: boolean;
    hideGeofences: boolean;
    greyscale: boolean;
    disablePopup: boolean;
    disableDefaultUi: boolean = false;
    showControlsOnRight: boolean;

    userDoesntHaveManageGeofencesPermission: boolean;

    mapInitialised: boolean;
    mapInitialisedPromise: angular.IPromise<google.maps.Map>;

    onPopupClick: () => void;
    onEditGeofenceClick: (args: { geofence: IGeofence }) => void;
    onMapLoaded: (args: { veriMap: IVeriMapComponent }) => void;
    onMapUnloaded: (args: { veriMap: IVeriMapComponent }) => void;
    onMapIdle: (args: { veriMap: IVeriMapComponent }) => void;
    onMapBoundsChanged: (args: { veriMap: IVeriMapComponent }) => void;
    onShowPopup: (args: { position: google.maps.LatLng, model?: any }) => void;
    onGeofenceClicked: (args: { geofence: IGeofence }) => void;
    onToggleResource: (args: { show: boolean }) => void;
    onToggleIgnitionOff: (args: { show: boolean }) => void;

    userOptions: ICombinedPreferences;
    clusteringEnabled = true;

    //lastFitMapLatLngs: google.maps.LatLng[] = [];

    childComponents: IVeriMapChildComponent[] = [];

    mapOptions: google.maps.MapOptions;
    trafficLayer: google.maps.TrafficLayer;

    private currentMouseLatLng: google.maps.LatLng;
    private currentMouseEvent: Event;
    private debouncedMapMouseMove: (mouseEvent: google.maps.MouseEvent) => void;

    static $inject = ["$q", "$element", "$timeout", "$transclude", "$scope", "sessionService", "mapService", "fullScreenService", "translationService", "$throttle", "accountFeatureService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly $element: JQuery,
        private readonly $timeout: angular.ITimeoutService,
        private readonly $transclude: angular.ITranscludeFunction,
        private readonly $scope: angular.IScope,
        private readonly sessionService: SessionService,
        private readonly mapService: MapService,
        private readonly fullScreenService: FullScreenService,
        private readonly translationService: TranslationService,
        private readonly $throttle: any,
        private readonly accountFeatureService: AccountFeatureService
    ) {

        this.initialiseMap();
    }

    $onInit() {
        if (!this.accountFeatureService.currentUserHasRole([UserRole.ManageGeofences])) {
            this.userDoesntHaveManageGeofencesPermission = true;
        }

        this.userOptions = this.sessionService.getItem<ICombinedPreferences>(SettingsName.UserOptions);

        this.debouncedMapMouseMove = this.$throttle(event => { this.mapMouseMove(event); }, 25);
    }

    $onDestroy() {
        // Clear our event listeners for the map
        if (this.mapOptions && this.mapObject) {
            google.maps.event.clearInstanceListeners(this.mapObject);
        }

        if (this.onMapUnloaded) {
            this.onMapUnloaded({ veriMap: this });
        }
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        if (!this.mapInitialised) {

            this.mapInitialisedPromise.then(() => {
                this.$onChanges(onChangesObj);
                this.translateGoogleButtons();
            });

            return
        }

        if (onChangesObj["greyscale"] && this.greyscale) {
            this.updateMapStyle();
        }

        if (onChangesObj["updateMapSize"] && this.mapObject) {
            // This is in a timeout to allow the maps object to actually resize before we update the maps notion of its size
            this.$timeout(() => {
                this.mapService.updateMapSize(this.mapObject);
            });
        }

        if (onChangesObj["updateMapSizeAndFit"] && this.mapObject) {
            // This is in a timeout to allow the maps object to actually resize before we update the maps notion of its size
            this.$timeout(() => {
                this.mapService.updateMapSize(this.mapObject);
                this.fitMapToAll();
            });
        }

        if (onChangesObj["mapOffset"]) {
            //this.fitMapToLastPosition();
            //this.mapService.updateMapSize(this.mapOptions.gMapObject);
        }

        if (onChangesObj["mapCenter"] && this.mapCenter) {

            if (this.mapCenter instanceof google.maps.LatLng) {
                this.mapObject.setCenter(this.mapCenter);
            }
            else if (this.mapCenter.latitude && this.mapCenter.longitude) {
                var latLng = new google.maps.LatLng(this.mapCenter.latitude, this.mapCenter.longitude);
                this.mapObject.setCenter(latLng);
            }
        }

        if (onChangesObj["mapZoom"] && this.mapZoom) {
            //console.log("map zoom", this.mapZoom);
            this.mapOptions.zoom = this.mapZoom;
            if (this.mapObject) {
                //console.log("yo");
                this.mapObject.setZoom(this.mapZoom);
            }
        }
    }

    registerChildComponent(childComponent: IVeriMapChildComponent) {
        this.childComponents.push(childComponent);
    }

    editGeofenceClick(geofence: IGeofence) {
        this.$scope.$broadcast(BroadcastEvent.openGeofenceEditor, geofence);

        if (this.onEditGeofenceClick) {
            this.onEditGeofenceClick({ geofence });
        }
    }

    deregisterChildComponent(childComponent: IVeriMapChildComponent) {
        var index = this.childComponents.indexOf(childComponent);
        this.childComponents.splice(index, 1);
    }

    getMap(): google.maps.Map {
        return this.mapObject;
    }

    getMapOffsetCenter(): google.maps.LatLng {
        const gmap = this.getMap();

        if (!this.mapOffset) {
            return gmap.getCenter();
        }

        return this.mapService.offsetLatLng(gmap, gmap.getCenter(), this.mapOffset.x, this.mapOffset.y);
    }

    panMap(latLng: google.maps.LatLng) {
        this.mapService.setOffsetCenter(this.mapObject, latLng, this.mapOffset);
    }

    setCenter(latLng: google.maps.LatLng) {
        this.mapService.setCenter(this.mapObject, latLng, this.mapOffset);
    }

    smoothPanAndZoomTo(latLng: google.maps.LatLng, targetZoom: number): angular.IPromise<void> {
        return this.mapService.smoothPanAndZoomTo(this.getMap(), latLng, targetZoom);
    }

    fitMap(latLngs: google.maps.LatLng[]) {
        if (!this.mapInitialised) {

            // If the map is not available then wait until it is
            this.mapInitialisedPromise
                .then(() => { this.fitMap(latLngs); })
                .catch(e => { console.error("mapReady error", e); });

            return;
        }

        if (latLngs == null || latLngs.length == 0) {
            return;
        }

        this.mapService.setMapBoundsWithOffset(this.mapObject, latLngs, this.getMapOffset());

    }

    fitMapToAll() {
        if (!this.childComponents) {
            return;
        }

        var latLngs: google.maps.LatLng[] = [];
        this.childComponents.forEach(child => {
            if (!child.getLatLngsForFitMap) {
                return;
            }

            var childLatLngs = child.getLatLngsForFitMap();

            if (childLatLngs) {
                childLatLngs.forEach(latlng => {
                    latLngs.push(latlng);
                });
            }
        });

        if (!latLngs.length) {
            return;
        }

        this.fitMap(latLngs);
    }

    toggleTrafficLayerVisibility() {
        if (this.trafficLayer) {
            this.trafficLayer.setMap(null);
            this.trafficLayer = null;
            return;
        }

        this.trafficLayer = new google.maps.TrafficLayer();
        this.trafficLayer.setMap(this.getMap());
    }

    toggleFullScreen() {
        this.fullScreenService.toggleAll();
    }

    showPopup(popupType: MapPopupType, position: google.maps.LatLng, model: any, hideControls?: boolean) {
        this.popupType = popupType;
        this.popupLatLng = position;
        this.popupModel = model;
        this.popupHideControls = hideControls;

        this.popupPosition = this.mapService.convertLatLngToPoint(position, this.getMap(), true);

        if (this.onShowPopup) {
            this.onShowPopup({ position: position, model: model });
        }

        this.$scope.$applyAsync(); 
    }

    hidePopup(popupType: MapPopupType, immediate: boolean) {
        if (!this.popupLatLng || this.popupType !== popupType) {
            return;
        }

        if (immediate) {
            this.$scope.$broadcast(BroadcastEvent.hidePopup);
        }
        else {
            this.$scope.$digest();
        }

        this.popupLatLng = null;
        this.popupPosition = null;
    }

    setPopupPosition(position: google.maps.LatLng): void {
        this.popupLatLng = position;
        this.popupPosition = this.mapService.convertLatLngToPoint(position, this.getMap(), true);
    }

    geofenceClicked(geofence: IGeofence) {
        if (this.onGeofenceClicked) {
            this.onGeofenceClicked({ geofence: geofence });
        }
    }

    mapZoomTest() {
        this.mapService.smoothPanAndZoomTo(this.mapObject, new google.maps.LatLng(52.23637, -0.935009), 16);
    }

    changeResource() {
        this.showResource = !this.showResource;

        if (this.onToggleResource) {
            this.onToggleResource({ show: this.showResource });
        }
    }

    changeIgnitionOffToggle() {
        this.showIgnitionOff = !this.showIgnitionOff;

        if (this.onToggleIgnitionOff) {
            this.onToggleIgnitionOff({ show: this.showIgnitionOff });
        }
    }

    clearData(): void {
        this.getMap().data.forEach((feature) => {
            this.getMap().data.remove(feature);
        });
    }

    // -----------------------------------------

    private initialiseMap() {

        // This looks complicated, but it allows child components to wait on this promise before everything is setup
        var mapDefer = this.$q.defer<google.maps.Map>();
        this.mapInitialisedPromise = mapDefer.promise;

        this.mapService.getMapAPIReadyPromise().then(() => {

            var container = this.$element.children(".google-map-container").first() as JQLite;

            this.setMapOptions();

            this.mapService.createMap(container[0], this.mapOptions).then(map => {
                this.mapObject = map;

                this.onMapInitialised(map);

                mapDefer.resolve(map);
            });
        });
    }

    private setMapOptions() {
        this.mapOptions = {
            center: new google.maps.LatLng(51.397, 0.644),
            zoom: 12,
            controlSize: 24,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scaleControl: true,
            streetViewControl: true,
            fullscreenControl: false,
            streetViewControlOptions: { position: google.maps.ControlPosition.LEFT_TOP },
            scaleControlOptions: {},
            zoomControlOptions: { position: google.maps.ControlPosition.LEFT_TOP },
            mapTypeControlOptions: { position: google.maps.ControlPosition.TOP_LEFT }
            //styles: this.greyMapStyle
        };

        if (this.disableDefaultUi) {
            this.mapOptions.disableDefaultUI = true;
            this.mapOptions.fullscreenControl = false;
            this.mapOptions.mapTypeControl = false;
            this.mapOptions.panControl = false;
            this.mapOptions.rotateControl = false;
            this.mapOptions.scaleControl = false;
            this.mapOptions.streetViewControl = false;
            this.mapOptions.zoomControl = false;
        }

        this.updateMapStyle();

        if (this.showControlsOnRight) {
            this.mapOptions.mapTypeControlOptions.position = google.maps.ControlPosition.TOP_RIGHT;

            this.mapOptions.zoomControlOptions.position = google.maps.ControlPosition.RIGHT_TOP;
            this.mapOptions.streetViewControlOptions.position = google.maps.ControlPosition.RIGHT_TOP;
        }
    }

    private translateGoogleButtons() {
        this.mapObject.mapTypes["roadmap"].name = this.translationService.t('veriMap.MapLabel');
        this.mapObject.mapTypes["satellite"].name = this.translationService.t('veriMap.SatelliteLabel');
        this.mapObject.mapTypes["terrain"].name = this.translationService.t('veriMap.TerrainLabel');
        this.mapObject.setOptions({ 'mapTypeControl': true });

    }

    private updateMapStyle() {
        this.mapOptions.styles = [];
        const currentMapType = this.mapObject?.getMapTypeId();

        if (this.greyscale && currentMapType != "satellite" && currentMapType != "hybrid") {
            this.mapOptions.styles = this.greyMapStyle;
        }

        if (this.mapObject) {
            this.mapObject.setOptions({
                styles: this.mapOptions.styles
            });
        }
    }

    private getMapOffset() {

        let offset = new google.maps.Point(0, 0);

        // CJE removed 7.6.21 - Unsure if this is needed anymore?
        //if (!this.disableDefaultUi) {
        //    offset.y = -60;
        //}

        if (this.mapOffset) {
            offset.x = this.mapOffset.x || offset.x;
            offset.y = this.mapOffset.y || offset.y;
        }

        return offset;
    }

    private mapMouseMove(mouseEvent: google.maps.MouseEvent) {
        var stopPropogation = false;

        var keys = Object.keys(mouseEvent);
        for (var i = 0; i < keys.length; i++) {
            if (MouseEvent.prototype.isPrototypeOf(mouseEvent[keys[i]])) {
                this.currentMouseEvent = mouseEvent[keys[i]];
            }
        }

        this.currentMouseLatLng = mouseEvent.latLng;

        this.childComponents.forEach(child => {
            if (child.onMouseMove && !stopPropogation) {
                stopPropogation = child.onMouseMove(this.currentMouseLatLng, this.currentMouseEvent);
            }
        });
    }

    private onMapInitialised(map: google.maps.Map) {
        this.mapInitialised = true;

        if (this.onMapLoaded) {
            this.onMapLoaded({ veriMap: this });

            this.childComponents.forEach(child => {
                if (child.onMapLoad) {
                    child.onMapLoad();
                }
            });
        }

        map.addListener("idle", () => {
            if (this.onMapIdle) {
                this.onMapIdle({ veriMap: this });
            }

            this.childComponents.forEach(child => {
                if (child.onMapIdle) {
                    child.onMapIdle();
                }
            })
        });

        // Perhaps need to rename "onMapBoundsChanged" later
        map.addListener("dragstart", () => {
            if (this.onMapBoundsChanged) {
                this.onMapBoundsChanged({ veriMap: this });
            }
        });

        map.addListener("click", () => {
            this.hidePopup(MapPopupType.Geofence, true);
            this.hidePopup(MapPopupType.Vehicle, true);
            this.hidePopup(MapPopupType.Custom, true);
        });

        map.addListener("mousemove", (mouseEvent: google.maps.MouseEvent) => {

            this.debouncedMapMouseMove(mouseEvent);
        });

        map.addListener("bounds_changed", (mouseEvent: google.maps.MouseEvent) => {
            if (this.popupType) {
                this.hidePopup(this.popupType, true);
            }
        });

        map.addListener("maptypeid_changed", (mouseEvent: google.maps.MouseEvent) => {
            if (this.mapOptions.mapTypeId != this.mapObject.getMapTypeId()) {
                this.mapOptions.mapTypeId = this.mapObject.getMapTypeId();
                this.updateMapStyle();
            }
        });

        map.addListener("rightclick", (event: google.maps.MouseEvent) => {
            if (this.$transclude.isSlotFilled("rightClickPopup")) {
                this.showPopup(MapPopupType.RightClick, event.latLng, null);

                this.$scope.$digest();
            }
        });

        this.mapService.enablePOI(map);

        // Needs to be done here when google has been loaded
        //this.mapOptions.streetViewControlOptions.position = google.maps.ControlPosition.LEFT_TOP;
        //this.mapOptions.zoomControlOptions.position = google.maps.ControlPosition.LEFT_TOP;
    }

    // https://snazzymaps.com/editor/customize/132
    greyMapStyle: google.maps.MapTypeStyle[] = [
        { "featureType": "administrative", "elementType": "geometry", "stylers": [{ "color": "#a7a7a7" }] },
        { "featureType": "administrative", "elementType": "labels.text.fill", "stylers": [{ "visibility": "on" }, { "color": "#737373" }] },
        { "featureType": "landscape", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#efefef" }] },
        { "featureType": "poi", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#dadada" }] },
        { "featureType": "poi", "elementType": "labels", "stylers": [{ "visibility": "off" }] },
        { "featureType": "poi", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
        { "featureType": "road", "elementType": "labels.text.fill", "stylers": [{ "color": "#696969" }, { "visibility": "on" }] },
        { "featureType": "road", "elementType": "labels.icon", "stylers": [{ "visibility": "off" }] },
        { "featureType": "road.highway", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }, { "visibility": "on" }] },
        { "featureType": "road.highway", "elementType": "geometry.stroke", "stylers": [{ "visibility": "on" }, { "color": "#b3b3b3" }] },
        { "featureType": "road.highway", "elementType": "labels.text.fill", "stylers": [{ "invert_lightness": true }] },
        { "featureType": "road.highway", "elementType": "labels.text.stroke", "stylers": [{ "invert_lightness": true }, { "visibility": "off" }, { "saturation": -100 }] },
        { "featureType": "road.highway.controlled_access", "elementType": "labels.icon", "stylers": [{ "visibility": "on" }, { "saturation": -100 }] },
        { "featureType": "road.arterial", "elementType": "geometry.fill", "stylers": [{ "color": "#ffffff" }] },
        { "featureType": "road.arterial", "elementType": "geometry.stroke", "stylers": [{ "color": "#d6d6d6" }] },
        { "featureType": "road.arterial", "elementType": "labels.text.fill", "stylers": [{ "visibility": "on" }, { "hue": "#ff0000" }] },
        { "featureType": "road.local", "elementType": "geometry.fill", "stylers": [{ "visibility": "on" }, { "color": "#ffffff" }, { "weight": 1.8 }] },
        { "featureType": "road.local", "elementType": "geometry.stroke", "stylers": [{ "color": "#d7d7d7" }] },
        { "featureType": "transit", "elementType": "all", "stylers": [{ "color": "#808080" }, { "visibility": "off" }] },
        { "featureType": "water", "elementType": "geometry.fill", "stylers": [{ "color": "#d3d3d3" }] }
    ];
}

export class VeriMapComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: string;
    transclude: { [slot: string]: string };

    constructor() {
        this.bindings = {
            mapCenter: "<",
            mapZoom: "<",
            mapOffset: "<",
            updateMapSize: "<",
            updateMapSizeAndFit: "<",

            showFullScreen: "@",
            showSearch: "<",
            includeVehicleSearch: "<",
            hideGeofences: "<",
            hideFitMap: "<",
            greyscale: "@",
            disablePopup: "<?",
            disableDefaultUi: "<",
            showControlsOnRight: "<",

            showResourceToggle: "<",
            showIgnitionOffToggle: "<",
            ignitionOffCount: "<",

            onPopupClick: "&",
            onEditGeofenceClick: "&",

            onMapLoaded: "&",
            onMapUnloaded: "&",
            onMapIdle: "&",
            onMapBoundsChanged: "&",
            onGeofenceClicked: "&",
            onShowPopup: "&",

            onToggleResource: "&",
            onToggleIgnitionOff: "&"
        };

        this.transclude = {
            //"mapClickHandler": "?mapClickHandler",
            "rightClickPopup": "?rightClickPopup",
            "customPopup": "?customPopup"
        }

        this.controller = VeriMapComponentController;
        this.template = require("./veriMap.html");
    }
}
